import React from "react";

const Plus: React.FC = () => (
<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="6.5" y1="2.18552e-08" x2="6.5" y2="13" stroke="white"/>
<line x1="13" y1="6.5" x2="-4.37114e-08" y2="6.5" stroke="white"/>
</svg>
);

export default Plus;
